import { useEffect, useRef } from 'react'
import { fireArcadeEvent } from '@/components/arcade/ArcadeToast'

/**
 * Watches a numeric score value and fires an arcade toast when it increases.
 */
export function useScoreToast(score: number | null | undefined, label = 'Points') {
  const prev = useRef<number | null>(null)

  useEffect(() => {
    if (score == null) return

    if (prev.current !== null && score > prev.current) {
      const delta = score - prev.current
      fireArcadeEvent({
        type: 'points',
        title: `+${delta} PTS`,
        subtitle: `Your bracket is heating up!`,
      })
    }

    prev.current = score
  }, [score, label])
}
